import { ContractTypeModel } from "../models/ContractTypeModel";
import API, { client } from "./API";

const ContractTypeService = {
  async getAllContractTypes() {
    const response = await API().get("ContractType", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularContractType(ct_id: number) {
    const response = await API().get("ContractType");
    return response.data.filter(
      (cur_ct: ContractTypeModel) => cur_ct.contractTypeId === ct_id
    )[0];
  },
  async createContractType(data: ContractTypeModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `ContractType/${id}` : "ContractType",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default ContractTypeService;
